import { generateClient } from 'aws-amplify/data';
import type { Schema } from '../../amplify/data/resource';

type DataClient = ReturnType<typeof generateClient<Schema>>;

// Singleton — must be created AFTER Amplify.configure() in main.tsx.
// Eager `export const client = generateClient()` at module load races bootstrap
// and causes "Amplify has not been configured" + broken model proxies (M_ID errors).
let clientInstance: DataClient | null = null;

export const getAmplifyClient = (): DataClient => {
  if (!clientInstance) {
    clientInstance = generateClient<Schema>();
  }
  return clientInstance;
};

/**
 * Lazy proxy: first property access runs generateClient() after configure.
 * Call sites keep using `client.models...` unchanged.
 */
export const client: DataClient = new Proxy({} as DataClient, {
  get(_target, prop, receiver) {
    const real = getAmplifyClient();
    const value = Reflect.get(real as object, prop, receiver);
    return typeof value === 'function' ? (value as (...a: unknown[]) => unknown).bind(real) : value;
  },
});
